import { render, staticRenderFns } from "./VDataTableWithPagination.vue?vue&type=template&id=336f6731&scoped=true&lang=pug"
import script from "./VDataTableWithPagination.vue?vue&type=script&lang=ts"
export * from "./VDataTableWithPagination.vue?vue&type=script&lang=ts"
import style0 from "./VDataTableWithPagination.vue?vue&type=style&index=0&id=336f6731&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336f6731",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
